import { AnimatedSaveBookmark, CloseButton } from "@louise/moon-ui";
import { EMBER } from "../../onboarding/theme";
import { semanticColors, withAlpha } from "@louise/theme/tokens";

export type ArticleReaderActionsProps = {
  bookmarked: boolean;
  onToggleFavorite: () => void;
  onClose: () => void;
  size?: number;
  savedLabel: string;
  saveAccessibilityLabel: string;
  removeAccessibilityLabel: string;
  closeAccessibilityLabel: string;
};

/** The shared save/close action group used by both reader action placements. */
export function ArticleReaderActions({
  bookmarked,
  onToggleFavorite,
  onClose,
  size = 28,
  savedLabel,
  saveAccessibilityLabel,
  removeAccessibilityLabel,
  closeAccessibilityLabel,
}: ArticleReaderActionsProps) {
  return (
    <>
      <AnimatedSaveBookmark
        bookmarked={bookmarked}
        onPress={onToggleFavorite}
        size={size}
        savedLabel={savedLabel}
        saveAccessibilityLabel={saveAccessibilityLabel}
        removeAccessibilityLabel={removeAccessibilityLabel}
        activeColor={EMBER.colors.warm}
        inactiveIconColor={EMBER.colors.textLight}
        activeBackgroundColor={withAlpha(semanticColors.accent.default, 0.13)}
      />
      <CloseButton
        onPress={onClose}
        accessibilityLabel={closeAccessibilityLabel}
        action="close_article_reader"
      />
    </>
  );
}

export default ArticleReaderActions;
